import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Dashboard/index.js"));
const SmartDocument = lazy(() => import("../pages/SmartDocument/index.js"));
const Login = lazy(() => import("../pages/User/index.js"));
const Forgotpassword = lazy(() => import("../pages/User/forgot-password.js"));
const Resetpasswordverify = lazy(() => import("../pages/User/verify-password.js"));
const Resetpassword = lazy(() => import ("../pages/User/reset-password.js"));
const Inbox = lazy(() => import("../pages/Inbox/index.js"));
const NotificationsPage = lazy(() => import("../pages/NotificationPage/index.js"));



const routes =[
  // {
  //   path: "/home",
  //   component: Dashboard,
  // },
  {
    path: "/smartdocument",
    component: SmartDocument,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/forgotpassword",
    component: Forgotpassword,
  },
  {
    path: "/passwordverify",
    component: Resetpasswordverify,
  },
  {
    path: "/resetpassword",
    component: Resetpassword,
  },
  {
    path: "/inbox",
    component: Inbox,
  },
  {
    path: "/notification",
    component: NotificationsPage,
  },
]

export default routes;